import {getBffSession} from "@project/sdk/security";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../shared/query/query-policies";
import {authKeys} from "../../auth-keys";

import {authSessionSchema} from "./get-session.schema";

export function getSessionQueryOptions() {
  return queryOptions({
    ...queryPolicyDefaults.ephemeral,
    queryFn: async () => {
      const session = await getBffSession();

      return authSessionSchema.parse(session);
    },
    queryKey: authKeys.session(),
  });
}
